<template>
  <div id="date-box">
    <div class="boxed-date">
      <span id="selected-day">{{ getDayofWeek }}</span>
      <span id="selected-date" :class="{ isblue: isBlue }">{{
        date.getDate()
      }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "DateBox",
  props: {
    date: {
      type: Object,
      default: new Date(),
    },
    isBlue: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    getDayofWeek() {
      let day = this.date.getDay();
      let weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
      return weekdays[day];
    },
  },
};
</script>

<style scoped>
#date-box {
  display: flex;
  flex-basis: auto;
  flex-shrink: 0;
}

.boxed-date {
  display: flex;
  flex-direction: column;
  text-align: center;
  margin-bottom: 10px;
}
.isblue {
  background-color: rgb(26, 115, 232);
  color: white;
}

#selected-date {
  font-weight: 400;
  font-size: 25px;
  border-radius: 100%;
  line-height: 46px;
  height: 46px;
  width: 46px;
  position: relative;
  margin-left: 10px;
  margin-top: -8px;
  display: flex;
  flex-direction: column;
}

#selected-day {
  line-height: 32px;
  position: relative;
  z-index: 5;
  color: #70757a;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.8px;
  margin-left: 8px;
  margin-top: 8px;
  text-transform: uppercase;
}
</style>
